var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-layout"},[_c('span',{staticClass:"label-group-title md-layout-item"},[_vm._t("title"),_vm._v(": ")],2),_c('span',{staticClass:"label-group-content md-layout-item"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }